import { create } from 'zustand';

interface NavCollapsedState {
  collapsed: boolean;
  toggle: () => void;
  set: (v: boolean) => void;
}

const STORAGE_KEY = 'cc-nav-collapsed';

function readInitial(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
}

function persist(v: boolean) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, v ? '1' : '0');
  }
}

export const useNavCollapsed = create<NavCollapsedState>((set) => ({
  collapsed: readInitial(),
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      persist(next);
      return { collapsed: next };
    }),
  set: (v) => {
    persist(v);
    set({ collapsed: v });
  },
}));
